const slugify = (name: string = '') => name.toLowerCase().replace(/ /g, '-');

export const StringUtils = {
  slugify,
};
